import * as Sentry from '@sentry/browser';

export default function clearSentryUser() {
  Sentry.configureScope(scope => scope.setUser(null));
}
